  <!-- Dialog title -->
  <div mat-dialog-title>
    <div class="success-popup-header d-flex justify-content-end">
      <img
        src="assets/icon/cross.svg"
        (click)="onClose()"
        class="cursor-pointer"
        alt="close"
      />
    </div>
  </div>
  <!-- Dialog content -->
  <div mat-dialog-content>
    <div class="row">
      <div class="col-4 offset-3">
        <div class="success-gif">
          <img src="assets/gif/success.gif" class="gif-image" alt="close" />
          <p class="text-light-green gif-icon-text">Lorem Ipsum</p>
        </div>
      </div>
      <div class="col-12">
        <p class="text-content text-center">
          Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi.
          Aliquam in hendrerit urna. Pellentesque sit amet sapien. Lorem ipsum
          dolor sit amet consectetur adipiscing elit Ut et massa mi.
        </p>
      </div>
      <div class="col-6 offset-2">
        <button class="submit-btn success-submission" type="submit">
          Submit
        </button>
      </div>
    </div>
  </div>
